<template>
<div class="home">

  <router-view></router-view>

</div>
</template>

<script>

// import CaseStudiesData from '@/store/CaseStudiesData'
// import '../assets/styles/animate.css'
// import Waypoints from 'waypoints'
// import Vue from 'vue'

// import Flickity from '@/components/Flickity'
// import Timetable from '@/components/Timetable'
// import Instagrams from '@/components/Instagrams'

// import WorkshopsRegular from '@/components/WorkshopsRegular'

export default {
  components: {
  },
  data () {
    return {
      hero: {
        image: 'https://cdn.shopify.com/s/files/1/0884/7454/products/Hato-Printing-Workshop-documentation-18_6a73ac37-37d1-4884-a236-3ac48ed6a524.jpg?v=1491209873',
        // image2: require('../assets/workshops/HatoWorkshopPlaceholder-3600-36.jpg'),
        reel1: '222338373',
        reel2: '222339794'
      }
    }
  },
  computed: {
    windowSize () {
      return window.innerWidth
    }
  },
  methods: {
    handleResize: function (event) {
      console.log('handleResize:', event)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {

}

.hero {
  position: relative;
  margin-bottom: 0rem;
}
.hero-text {
  position: absolute;
  /*bottom: 30px;
  left: 20px;*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;

  font-size: 50px;
  line-height: 1.2;
  font-weight: 500;
  /*letter-spacing: -1px;
  letter-spacing: 0;*/
  max-width: 22em;
  color: white;
  top: ;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  margin: auto;
}
.hero-wrapper {
  position: relative;
  margin: 0 0;
  max-width: 100%;
  padding-bottom: 50%;
  overflow: hidden;
}
.hero-wrapper .iframe-wrapper {
  margin: 0;
  position: absolute;
  pointer-events: none;
}
.hero-wrapper .background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
video {
  display: block;
  width: 100%;
}

.content-image {
  margin: auto;
  margin: 1em auto;
  max-width: 500px;
}

.content-text {
  margin: auto;
  padding: 0 1rem;
  margin: 2rem auto;
  text-align: center;
  max-width: 900px;
}

h2 {
  margin-top: 0;
  text-align: center;
}

.router-link-active {
  border-bottom: 1px solid;
}


@media screen and (max-width: 1024px) {

}
@media screen and (max-width: 768px) {
  .hero-text {
    font-size: 40px;
  }
  .hero-wrapper {
    padding-bottom: 60%;
  }
}
@media screen and (max-width: 640px) {
  .hero-text {
    font-size: 22px;
  }
  .hero-wrapper {
    padding-bottom: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?646c3a5b